module.exports = __webpack_public_path__ + "img/cheap.8d3f43fd.png";